import { useEffect } from 'react';
import { useEditorState } from './EditorProvider';
import { useDebounce } from './hooks';
export var ChangeHandler = function (_a) {
    var handleChange = _a.handleChange, transformer = _a.transformer, _b = _a.debounce, debounce = _b === void 0 ? 0 : _b;
    var state = useEditorState();
    var debouncedDoc = useDebounce(state.doc, debounce);
    useEffect(function () {
        handleChange(transformer.serialize(debouncedDoc));
    }, [handleChange, transformer, debouncedDoc]);
    return null;
};
